const getBaseUrl = () => {
  switch (process.env.REACT_APP_MODE) {
    case 'dev':
      return process.env.REACT_APP_DEV_URL;
    case 'training':
      return process.env.REACT_APP_TRAINING_URL;
    case 'internal':
      return process.env.REACT_APP_INTERNAL_URL;
    default:
      return process.env.REACT_APP_INTERNAL_URL;
  }
};

const env = {
  MODE: process.env.REACT_APP_MODE || 'dev',
  API_BASE_URL: getBaseUrl(),
  KEYCLOAK_URL: process.env.REACT_APP_KEYCLOAK_URL || 'https://identity.crestech.co:8443',
  KEYCLOAK_REALM: process.env.REACT_APP_KEYCLOAK_REALM || 'FMPS',
  KEYCLOAK_CLIENT_ID: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'fmps-web-app',
  KEYCLOAK_SCOPE: process.env.REACT_APP_KEYCLOAK_SCOPE || 'fmps-backoffice-web-app',
  AGENTS_GROUP_ID: process.env.REACT_APP_AGENTS_GROUP_ID || '6ad45b5f-92dd-421f-b033-f85d729ba2e5',
  TELLERS_GROUP_ID: process.env.REACT_APP_TELLERS_GROUP_ID || 'a6a6acf0-e064-4196-951e-a8a36c3ca02d',
  IS_DEV: process.env.NODE_ENV !== 'production',
};

export default env;
